<template>
  <div>
     <el-pagination
      class="myPage"
      :hide-on-single-page="true"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="props.currentPage"
      :page-size="props.pageSize"
      layout="prev, pager, next, jumper"
      :total="props.total">
    </el-pagination>
  </div>
</template>

<script setup>
import { watch } from 'vue';

const props = defineProps({
    total: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 1
    }
})
watch(() => props.currentPage,(newVal, oldVal) => {
  console.log(newVal, oldVal)
},{deep: true})
const handleSizeChange = (val) => {

}
const handleCurrentChange = (val) => {
    // this.$emit('current-change', val)
  }
// export default {
//   name: 'myPagination',
//   data () {
//     return {
//       currentNumber: 1
//     }
//   },
//   props: {
//     total: {
//       type: Number,
//       default: 0
//     },
//     pageSize: {
//       type: Number,
//       default: 10
//     },
//     currentPage: {
//       type: Number,
//       default: 1
//     }
//   },
//   watch: {
//     currentPage: {
//       handler (val) {
//         this.currentNumber = val
//       }
//     }
//   },
//   methods: {
//     handleSizeChange (val) {
//     },
//     handleCurrentChange (val) {
//       this.$emit('current-change', val)
//     }
//   }
// }
</script>

<style>
  .pagination{
    margin-top: 20px;
    display: flex;
    justify-content: end;
  }
  .myPage .number{
    font-size:14px!important;
    font-weight:400!important;
    color:rgba(11,11,10,1)!important;
  }
  .myPage .el-pagination__editor.el-input .el-input__inner,.el-pagination__editor.el-input{
    width:60px;
    height:28px;
    border-radius:3px;
    /* border:1px solid rgba(220,223,230,1); */
    font-size:14px;
    font-weight:400;
    color:rgba(96,98,102,1);
  }
  .myPage .el-pagination__editor{
    margin: 0 6px;
  }
  .myPage  .number.active{
    color: rgba(71,143,142,1)!important
  }
  .myPage .el-pagination__jump{
    font-size:14px;
    font-weight:400;
    color:rgba(96,98,102,1);
  }
  .myPage{
    background-color: #fff;
    position: fixed;
    z-index: 200;
    left: 50%;
    transform: translateX(-50%);
    bottom: 25px;
  }
</style>
